import { render, staticRenderFns } from "./live-ing.vue?vue&type=template&id=a7470a66&scoped=true&"
import script from "./live-ing.vue?vue&type=script&lang=js&"
export * from "./live-ing.vue?vue&type=script&lang=js&"
import style0 from "./live-ing.vue?vue&type=style&index=0&id=a7470a66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7470a66",
  null
  
)

export default component.exports